import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SubscriberMelody} from "../../model/subscriber-melody";
import {AudioService} from "../../services/audio.service";
import {Subscription} from "rxjs";
import {ModalsService} from "../../services/modals.service";
import {SubscriberService} from "../../services/subscriber.service";
import {SubscriptionStatus} from "../../model/subscription-status";

declare var $: any;

@Component({
  selector: '[app-subscriber-melody-item]',
  templateUrl: './subscriber-melody-item.component.html',
  styleUrls: ['./subscriber-melody-item.component.css']
})
export class SubscriberMelodyItemComponent implements OnInit, OnDestroy {
  @Input() melody: SubscriberMelody;
  @Input() showControls: boolean;

  @ViewChild("progressBar") private progressBar: ElementRef;

  progressBarInitialized: boolean;
  showDateEndPromo: boolean;
  privetPlusSubscriptionStatus: SubscriptionStatus;
  subscription: Subscription;

  constructor(private readonly subscriberService: SubscriberService,
              private readonly audioService: AudioService,
              private readonly modalsService: ModalsService) {
    this.progressBarInitialized = false;
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.audioService.getState()
        .subscribe(state => {
          if (state.isPlaying && this.melody.isPlaying) {
            this.initProgressBar();
            if (state.currentTime && state.duration && this.progressBarInitialized) {
              $(this.progressBar.nativeElement).circleProgress('value', Number(state.currentTime) / Number(state.duration));
            }
          } else {
            this.destroyProgressBar();
          }
        })
    );

    this.subscription.add(
      this.subscriberService.subscriber.subscribe(subscriber => {
        if (subscriber != null) {
          this.showDateEndPromo = subscriber.privetPlusStatus === SubscriptionStatus.ACTIVE ;
        }
      })
    );
  }

  formattedDonatorPhone(): string {
    const raw = this.melody?.msisdnDonator;
    if (raw?.length !== 11) return raw || '';
    return `+${raw[0]} ${raw.slice(1, 4)}-${raw.slice(4, 7)}-${raw.slice(7, 9)}-${raw.slice(9)}`;
  }

  play(): void {
    this.audioService.togglePlay(this.melody);
  }

  initProgressBar(): void {
    if (!this.progressBarInitialized) {
      $(this.progressBar.nativeElement).circleProgress({
        startAngle: -Math.PI / 2,
        value: 0,
        animation: true,
        size: 36,
        fill: {color: "#191c22"},
        emptyFill: "#ffffff",
        strokeLine: 20
      });
      this.progressBarInitialized = true;
    }
  }

  destroyProgressBar(): void {
    if (this.progressBarInitialized) {
      const progressBar = $(this.progressBar.nativeElement);
      const circleProgress = progressBar.data('circle-progress');
      $(circleProgress.canvas).remove();
      progressBar.removeData('circle-progress');

      this.progressBarInitialized = false;
    }
  }

  openSettings(): void {
    this.modalsService.showSubscriberMelodySettings(this.melody);
  }

  ngOnDestroy(): void {
    if (this.melody.isPlaying) {
      this.audioService.stopTrack();
    }
    if (this.progressBarInitialized) {
      this.destroyProgressBar();
    }
    this.subscription.unsubscribe();
  }

  getPaidToDate(paidFrom: string | Date): Date {
    const date = new Date(paidFrom);
    date.setDate(date.getDate() + 10);
    return date;
  }
}
